import { render, staticRenderFns } from "./CreateAppUsersStructure.vue?vue&type=template&id=3b5cd1d5&scoped=true"
import script from "./CreateAppUsersStructure.vue?vue&type=script&lang=js"
export * from "./CreateAppUsersStructure.vue?vue&type=script&lang=js"
import style0 from "./CreateAppUsersStructure.vue?vue&type=style&index=0&id=3b5cd1d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5cd1d5",
  null
  
)

export default component.exports